import React from 'react';
import { HiOutlineX } from 'react-icons/hi';

const PainelSecaoConsulta = ({ consultaFeedback, sectionStyle, onFechar }) => {
  return (
    <div className="briefing-ai-page__panel-section" style={sectionStyle}>
      <div className="briefing-ai-page__panel-section-head">
        <h2 className="briefing-ai-page__response-title">Consulta AI</h2>
        <button
          type="button"
          className="briefing-ai-page__panel-section-close"
          onClick={onFechar}
          aria-label="Limpar e fechar consulta AI"
          title="Limpar consulta"
        >
          <HiOutlineX size={18} aria-hidden />
        </button>
      </div>
      <div className="briefing-ai-page__response-box briefing-ai-page__response-box--external-ok">
        <pre className="briefing-ai-page__response-box-pre">
          {JSON.stringify(consultaFeedback, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default PainelSecaoConsulta;
